import {
  CLIENT_RESET_PASSWORD_V2,
  CLIENT_RESET_PASSWORD_V2_SUCCESS,
  CLIENT_RESET_PASSWORD_V2_ERROR,
  CLIENT_RESET_PASSWORD_V2_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ClientResetPasswordV2 = (state = initialState, action) => {
  switch (action.type) {
    case CLIENT_RESET_PASSWORD_V2:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CLIENT_RESET_PASSWORD_V2_SUCCESS:
      state = {
        ...state,
        data: action?.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case CLIENT_RESET_PASSWORD_V2_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CLIENT_RESET_PASSWORD_V2_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ClientResetPasswordV2;
